"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMathJaxContext = exports.default = void 0;

var _simpleLoadScript = _interopRequireDefault(require("simple-load-script"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const MathJaxContext = /*#__PURE__*/(0, _react.createContext)(null);

const Provider = props => {
  const url = props.url || DEFAULT_URL;
  const options = props.options || DEFAULT_OPTIONS;
  const [MathJax, setMathJax] = (0, _react.useState)(options);
  const [isMathJaxLoaded, setIsMathJaxLoaded] = (0, _react.useState)(false);
  window.MathJax = MathJax;
  (0, _react.useEffect)(() => {
    (0, _simpleLoadScript.default)(url).then(onLoad).catch(onErr);
  }, [url]);

  function onLoad() {
    setMathJax(window.MathJax);
    setIsMathJaxLoaded(true);
  }

  function onErr(err) {
    console.log(err);
  }

  return /*#__PURE__*/_react.default.createElement(MathJaxContext.Provider, _extends({
    value: isMathJaxLoaded ? MathJax : null
  }, props));
};

const DEFAULT_OPTIONS = {};
const DEFAULT_URL = "https://cdn.jsdelivr.net/npm/mathjax@3.0.1/es5/tex-mml-chtml.js";

const useMathJaxContext = () => (0, _react.useContext)(MathJaxContext);

exports.useMathJaxContext = useMathJaxContext;
var _default = Provider;
exports.default = _default;